import React from 'react';
import { Route, Switch } from 'react-router-dom';

import * as Page from './index';

export const routes = [
    {
        exact: true,
        path: '/100-10-1/messages',
        component: Page.CXIMessagesIndex,
    },
    {
        exact: true,
        path: '/100-10-1/messages/:matchId',
        component: Page.CXIMessagesMatch,
    },
];

export const CXIMessagesRoutes = props => (
    <Switch>
        {routes.map(r => {
            const Component = r.component || React.createComponent(r.toRender);
            const routeProp = { ...r, component: undefined };
            return <Route key={r.path} {...routeProp} render={() => <Component {...props} />} />;
        })}
    </Switch>
);
export default CXIMessagesRoutes;
